export default Object.freeze({
	DRIVER: 1,
	STATE_ID: 2,
	PASSPORT: 3
});